import React from 'react'

const TransactionsStatusBadge = ({status}) => {
  return (
    <div  className={` status-badge  status-transaction-${status}`}>
        {status ==="success"?"مقبول":status ==="pending"?"في الانتظار":status ==="refused"?"مرفوض":""}
    </div>
  )
}

export default TransactionsStatusBadge     